import { Routine } from 'redux-saga-routines';
import {
  findAllPositionsRoutine,
  fetchRecentPositionsRoutine
} from './routines';
import { IReferenceReqPosition } from '../../common/models/position/IReferenceReqPosition';

export type ChoosePositionState = {
  loading: boolean;
  positions: IReferenceReqPosition[];
  total: number;
};

const initialState: ChoosePositionState = {
  loading: true,
  positions: [],
  total: 0
};

export const choosePosition = (
  state: ChoosePositionState = initialState,
  { type, payload }: Routine<any>
): ChoosePositionState => {
  switch (type) {
    case fetchRecentPositionsRoutine.TRIGGER:
      return {
        ...state,
        loading: true
      };
    case findAllPositionsRoutine.TRIGGER:
      return {
        ...state,
        loading: !payload.from
      };
    case findAllPositionsRoutine.SUCCESS:
      const positions = payload.reset ? payload.items : [...state.positions, ...payload.items];
      return {
        ...state,
        positions,
        total: payload.total,
        loading: false
      };
    case fetchRecentPositionsRoutine.SUCCESS:
      return {
        ...state,
        positions: payload,
        total: payload.length,
        loading: false
      };
    case findAllPositionsRoutine.FAILURE:
    case fetchRecentPositionsRoutine.FAILURE:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
};
